import { Injectable } from "@angular/core";
import { BaseStyle } from "primeng/base";

@Injectable({ providedIn: "root" })
export class SelectlistStyle extends BaseStyle {
  override name = "selectlist";

  override theme = ({ dt }: any): string => `
    .ui-selectlist-list {
      display: flex;
      flex-direction: column;
      gap: ${dt("selectlist.list.gap")};
      list-style: none;
      padding: 0;
      margin: 0;
    }

    .ui-selectlist-link {
      display: flex;
      flex-direction: column;
      gap: ${dt("selectlist.item.gap")};
      padding: ${dt("selectlist.item.padding")};
      border-radius: ${dt("selectlist.item.border.radius")};
      border-color: ${dt("selectlist.item.border.color")};
      border-width: ${dt("selectlist.item.border.width")};
      background: ${dt("selectlist.item.background")};
      transition: border-color ${dt("selectlist.transition.duration")};
    }

    .ui-selectlist-link.active,
    .ui-selectlist-link:hover {
      border-color: ${dt("selectlist.item.active.border.color")};
      box-shadow: 0 0 0 ${dt("selectlist.item.active.outline.width")} ${dt("selectlist.item.active.border.color")} inset;
    }

    .ui-selectlist-link:focus {
      border-color: ${dt("selectlist.item.focus.border.color")};
      box-shadow: 0 0 0 ${dt("selectlist.item.focus.outline.width")} ${dt("selectlist.item.focus.border.color")} inset;
    }

    .ui-selectlist-label {
      font-size: ${dt("selectlist.label.font.size")};
      font-weight: ${dt("selectlist.label.font.weight")};
      line-height: ${dt("selectlist.label.font.leading")};
      color: ${dt("selectlist.label.color")};
    }

    .ui-selectlist-description {
      font-size: ${dt("selectlist.description.font.size")};
      font-weight: ${dt("selectlist.description.font.weight")};
      line-height: ${dt("selectlist.description.font.leading")};
      color: ${dt("selectlist.description.color")};
    }
  `;

  override classes = {
    root: "ui-selectlist",
    list: "ui-selectlist-list",
    item: "ui-selectlist-item",
    link: "ui-selectlist-link",
    label: "ui-selectlist-label",
    description: "ui-selectlist-description",
  };
}
